module.exports = __webpack_public_path__ + "static/media/casa.b5abc407.png";